module.exports = __webpack_public_path__ + "static/slider-1-king-starboard-22da60854ad74a460a8c32f496f15158.png";